import palette from '~/theme/dark/palette'

export default {
  styleOverrides: {
    dayLabel: {
      color: palette.text.secondary
    }
  }
}
